export namespace serializeForLlm {
  export function file(file: { path: string; contents: string }): string {
    return `<file path='${file.path}'>\n${file.contents}\n</file>`
  }

  export function webContent(url: string, content: string): string {
    return `<web_content source='${url}'>\n${content}\n</web_content>`
  }
}
